import { getPropertyValue } from 'marketing-platform-lib/utils/crmUtils';
import { useMemo } from 'react';
import useGetCustomProperties from './useGetCustomProperties';
export default function useGetAssignedCustomProperties({
  crmObject,
  objectTypeId,
  requiredGates
}) {
  const {
    customProperties: customPropertyDefinitions,
    isLoadingCustomProperties,
    customPropertiesError
  } = useGetCustomProperties({
    objectTypeId,
    requiredGates
  });
  const assignedCustomProperties = useMemo(() => {
    if (isLoadingCustomProperties || customPropertiesError) return [];
    return customPropertyDefinitions.reduce((acc, {
      property
    }) => {
      const value = getPropertyValue(crmObject, property.name);
      if (value !== null && value !== undefined) {
        acc.push({
          name: property.name,
          value
        });
      }
      return acc;
    }, []);
  }, [crmObject, customPropertiesError, customPropertyDefinitions, isLoadingCustomProperties]);
  return useMemo(() => ({
    assignedCustomProperties,
    isLoadingAssignedCustomProperties: isLoadingCustomProperties,
    assignedCustomPropertiesError: customPropertiesError
  }), [assignedCustomProperties, customPropertiesError, isLoadingCustomProperties]);
}